import { FC, ReactNode, useMemo } from 'react';

import { cn } from 'utils/helpers';

interface BADGE_PROPS {
  count?: number;
  className?: string;
}

const Badge: FC<BADGE_PROPS> = ({ count, className }) => {
  const renderCount = useMemo(() => ((count ?? 0) > 99 ? 99 : count), [count]);

  return (
    <div
      className={cn(
        'absolute top-[-8px] right-[-8px]',
        'bg-danger-base',
        'h-[20px] w-[20px]',
        'border-2 border-fill-tertiary',
        'rounded-full',
        'flex items-center',
        className,
      )}
    >
      <div
        className={cn(
          'm-auto',
          'text-center text-[10px] text-fill-tertiary',
          'font-semibold',
        )}
      >
        {renderCount}
      </div>
    </div>
  );
};

export default Badge;

type PROPS = {
  count: number;
  icon: ReactNode;
  [key: string]: any;
};

export const BadgeBell: FC<PROPS> = ({ count, icon, ...props }) => (
  <div className="relative" {...props}>
    <div className="icon h-[20px]">{icon}</div>
    {Boolean(count) && <Badge count={count} />}
  </div>
);
